import { Injectable, inject, Injector } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as featureActions from '../../index';
import {Store} from '@ngrx/store';
import {Observable, of} from 'rxjs';
import * as fromStore from '../../../store';
import {catchError, combineLatest, map, mergeMap, switchMap, withLatestFrom} from 'rxjs/operators';
import { CompanionActions } from '../actions/companion.actions';
import {CompanionService} from '../../../services/companion.service';
import { Companion, Device } from '../companion.model';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';
import { TranslateService } from '@ngx-translate/core';
import {Router} from '@angular/router';



@Injectable()
export class CompanionEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private companionService = inject(CompanionService);
  private router = inject(Router);

  private injector = inject(Injector);



  constructor() {}

  ReadCompanionList$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.CompanionActionTypes.GetCompanions),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ReadCompanionList
      };
      return this.companionService.ReadCompanionList(user.otp).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.UpsertCompanions(res.msg.body),
            new featureActions.GetCompanionRuleList()];
          } else {
            return of(new featureActions.NoCompanions());
          }
        }),
        catchError((error) => {
          // updateRes.errmsg = error.error.errmsg.body;
          //   return [new featureActions.GetCompanionsFail(),
          //           new featureActions.UpdateInfoFailAction(updateRes)];
          return [new featureActions.GetCompanionsFail()];
        })
      );
    })
  ));
  DeleteCompanion$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.CompanionActionTypes.DeleteCompanion),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = {
          otp: user.otp,
          Id: action.payload
        };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.DeleteCompanion
      };
      return this.companionService.DeleteCompanion(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.GetCompanions(),
            new featureActions.GetCompanionRuleList(),
            new featureActions.UpdateInfoSuccessAction({ ...updateRes, msg: this.injector.get(TranslateService).instant('Delete Companion Success'), result: true })];
          } else {
            return [new featureActions.DeleteCompanionFail(),
                    new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.msg.body })];
          }
        }),
        catchError((error) => {
            return [new featureActions.DeleteCompanionFail(),
                    new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error.error.errmsg.body })];
        })
      );
    })
  ));
  ReadCompanionOverView$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.CompanionActionTypes.GetCompanionsOverView),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.GetCompanionsOverView
      };
      return this.companionService.ReadCompanionOverView(user.otp).pipe(
        map((res: any) => {
          if (res.result) {
            return new featureActions.GetCompanionsOverViewSuccess(res.msg.body);
          } else {
            return new featureActions.GetCompanionsOverViewFail();
          }
        }),
        catchError((error) => {
          // updateRes.errmsg = error.error.errmsg.body;
          //   return [new featureActions.GetCompanionsOverViewFail(),
          //           new featureActions.UpdateInfoFailAction(updateRes)];
          return [new featureActions.GetCompanionsOverViewFail()];
        })
      );
    })
  ));
  SentKeyToApp$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.CompanionActionTypes.SendKeyToApp),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.SendToApp
      };
      const param = {
        otp: user.otp,
      };
      return this.companionService.SentKeyToApp(param).pipe(
        map((res: any) => {
          if (res.result) {
            return new featureActions.GetPreferences(res.msg.body);
          } else {
            return new featureActions.SendKeyToAppFail();
          }
        }),
        catchError((error) => {
          // updateRes.errmsg = error.error.errmsg.body;
          //   return [new featureActions.SendKeyToAppFail(),
          //           new featureActions.UpdateInfoFailAction(updateRes)];
          return [new featureActions.SendKeyToAppFail()];
        })
      );
    })
  ));
  ReadCompanionProtectionProcessDevice$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.CompanionActionTypes.GetCompanionProtectionProcessDevice),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = {
        otp : user.otp,
        Hash : action.payload.Hash
      };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.GetCompanionProtectionProcess
      };
      return this.companionService.ReadCompanionProtectionProcessDevice(param).pipe(
          switchMap((res: any) => {
          if (res.result) {
              return [
                new featureActions.GetCompanionProtectionProcessDeviceSuccess(res),
                new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true })];
          } else {
            return [new featureActions.GetCompanionProtectionProcessDeviceFail(),
                    new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: this.injector.get(TranslateService).instant('Not confirmed. Please try again at Companion section.') })];
          }
        }),
        catchError((error) => {
            // updateRes.errmsg = this.injector.get(TranslateService).instant('Not confirmed. Please try again at Companion section.');
            // return [new featureActions.GetCompanionProtectionProcessDeviceFail(),
            //         new featureActions.UpdateInfoFailAction(updateRes)];
            return [new featureActions.GetCompanionProtectionProcessDeviceFail()];
        })
      );
    })
  ));
  ConfirmCompanionProtectionProcess$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.CompanionActionTypes.ConfirmCompanionProtectionProcess),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = {
        otp : user.otp,
        TriggerId : action.payload.TriggerId,
        From : action.payload.From
      };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ConfirmCompanionProtectionProcess
      };
      return this.companionService.ConfirmCompanionProtectionProcess(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg: this.injector.get(TranslateService).instant('Read companion confirm success') })];
          } else {
            return [new featureActions.ConfirmCompanionProtectionProcessFail(),
                    new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.msg.body })];
          }
        }),
        catchError((error) => {
          this.router.navigate(['/companion']);
          // updateRes.errmsg = error.error.errmsg.body;
          //   return [new featureActions.ConfirmCompanionProtectionProcessFail(),
          //           new featureActions.UpdateInfoFailAction(updateRes)];
          return [new featureActions.ConfirmCompanionProtectionProcessFail()];
        })
      );
    })
  ));
  SendKeyOfCompanionProtectionProcess$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.CompanionActionTypes.SendKeyOfCompanionProtectionProcess),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = {
        otp : user.otp,
        TriggerIdList: action.payload.TriggerIdList,
        AuthId: action.payload.AuthId,
        AuthType: action.payload.AuthType,
        From : action.payload.From
      };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.SendKeyOfCompanionProtectionProcess
      };
      return this.companionService.SendKeyOfCompanionProtectionProcess(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.GetCompanions(),
              new featureActions.GetCompanionRuleList(),
              new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg: this.injector.get(TranslateService).instant('Send key of companion protection processs success') })];
          } else {
            return [new featureActions.SendKeyOfCompanionProtectionProcessFail(),
                    new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.msg.body })];
          }
        }),
        catchError((error) => {
          // updateRes.errmsg = error.error.errmsg.body;
          //   return [new featureActions.SendKeyOfCompanionProtectionProcessFail(),
          //           new featureActions.UpdateInfoFailAction(updateRes)];
          return [new featureActions.SendKeyOfCompanionProtectionProcessFail()];
        })
      );
    })
  ));
  ResendDataOfCompanionProtectionProcess$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.CompanionActionTypes.ResendDataOfCompanionProtectionProcess),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = {
        otp : user.otp,
        CmpnId: action.payload.CmpnId,
        From : action.payload.From
      };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ResendDataOfCompanionProtectionProcess
      };
      return this.companionService.ResendDataOfCompanionProtectionProcess(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.ResendDataOfCompanionProtectionProcessSuccess(res.msg.body),
              new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg: this.injector.get(TranslateService).instant('Resend data of companion protection process') })];
          } else {
            return [new featureActions.ResendDataOfCompanionProtectionProcessFail(),
                    new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.msg.body })];
          }
        }),
        catchError((error) => {
          // updateRes.errmsg = error.error.errmsg.body;
          //   return [new featureActions.ResendDataOfCompanionProtectionProcessFail(),
          //           new featureActions.UpdateInfoFailAction(updateRes)];
          return [new featureActions.ResendDataOfCompanionProtectionProcessFail()];
        })
      );
    })
  ));
  StopCompanionProtectionProcess$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.CompanionActionTypes.StopCompanionProtectionProcess),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = {
        otp : user.otp,
        CmpnId: action.payload.CmpnId,
        From : action.payload.From
      };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.StopCompanionProtectionProcess
      };
      return this.companionService.StopCompanionProtectionProcess(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
              new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg: this.injector.get(TranslateService).instant('Stop companion protection processs success') })];
          } else {
            return [new featureActions.StopCompanionProtectionProcessFail(),
                    new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.msg.body })];
          }
        }),
        catchError((error) => {
          // updateRes.errmsg = error.error.errmsg.body;
          //   return [new featureActions.StopCompanionProtectionProcessFail(),
          //           new featureActions.UpdateInfoFailAction(updateRes)];
          return [new featureActions.StopCompanionProtectionProcessFail()];
        })
      );
    })
  ));
  UpdateCompanionOfflineNotification$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.CompanionActionTypes.UpdateCompanionOfflineNotification),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = {
        otp : user.otp,
        CompanionOfflineNotify: action.payload
      };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.UpdateCompanionOfflineNotify
      };
      return this.companionService.UpdateCompanionOfflineNotification(param).pipe(
        switchMap((res: any) => {
          if (!res.Flag) {
            return [
              new featureActions.UpdateCompanionOfflineNotificationFail(),
              new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.msg.body })];
          } else {
            const msg = action.payload
              ? this.injector.get(TranslateService).instant('You have enabled companion offline notification successful.')
              : this.injector.get(TranslateService).instant('You have disabled companion offline notification successful.');
            return [
              // new featureActions.GetPreferences(),
              new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg })];
          }
        }),
        catchError((error) => {
          // updateRes.errmsg = error.error.errmsg.body;
          // return [
          //   new featureActions.UpdateCompanionOfflineNotificationFail(),
          //   new featureActions.UpdateInfoFailAction(updateRes)];
          return [new featureActions.UpdateCompanionOfflineNotificationFail()];
        })
      );
    })
  ));
  UpdateCompanionReceipt$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.CompanionActionTypes.UpdateCompanionReceipt),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = {
        otp : user.otp,
        CompanionReceipt: action.payload
      };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.UpdateCompanionReceipt
      };
      return this.companionService.UpdateCompanionReceipt(param).pipe(
        switchMap((res: any) => {
          if (!res.Flag) {
            return [
              new featureActions.UpdateCompanionReceiptFail(),
              new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.msg.body })];
          } else {
            return [
              // new featureActions.GetPreferences(),
              new featureActions.UpdateInfoSuccessAction({ ...updateRes, msg: '', result: true })];
          }
        }),
        catchError((error) => {
          // updateRes.errmsg = error.error.errmsg.body;
          // return [
          //   new featureActions.UpdateCompanionReceiptFail(),
          //   new featureActions.UpdateInfoFailAction(updateRes)];
          return [new featureActions.UpdateCompanionReceiptFail()];
        })
      );
    })
  ));
}
